import { ChartData } from '@/types';
import { Value } from './Value/Value';
import { Indicator } from './Indicator/Indicator';
import { Label } from './Label/Label';
import styles from './barStyles.module.scss';

interface BarProps {
  data: ChartData;
  maxValue: number;
  isFirstTab: boolean;
}

export const Bar = ({ data, maxValue, isFirstTab }: BarProps) => {
  function getHeightPercentage() {
    const fullHeight = maxValue;
    const barValue = isFirstTab ? data.value.credit : data.value.income;
    return (Number(barValue) / fullHeight) * 100;
  }

  return (
    <li className={styles.wrapper}>
      <Value isFirstTab={isFirstTab} unit={data.unit} value={data.value} />
      <div
        className={styles.bar}
        style={{
          height: getHeightPercentage() + '%',
        }}
      >
        <Indicator isFirstTab={isFirstTab} indicator={data.indicator} />
        <Label isFirstTab={isFirstTab} label={data.label} />
      </div>
    </li>
  );
};
